import React, { useEffect } from 'react'
import { motion } from 'framer-motion'

const LoadingScreen = ({ onLoadingComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onLoadingComplete()
    }, 3000)

    return () => clearTimeout(timer)
  }, [onLoadingComplete])

  return (
    <motion.div exit={{ opacity: 0 }} className="fixed inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-50 flex items-center justify-center z-50 flex-col space-y-6 sm:space-y-8 px-4">
      <div className="absolute inset-0 overflow-hidden">
        <motion.div animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }} transition={{ duration: 4, repeat: Infinity }} className="absolute inset-0 bg-gradient-radial from-accent-maroon/20 to-transparent" />
      </div>

      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          animate={{ y: [0, -100, 0], x: [0, Math.sin(i) * 50, 0], opacity: [0, 1, 0] }}
          transition={{ duration: 3, delay: i * 0.3, repeat: Infinity }}
          className="absolute w-1.5 h-1.5 sm:w-2 sm:h-2 bg-accent-maroon rounded-full"
          style={{ left: `${15 + i * 15}%`, top: '50%' }}
        />
      ))}

      <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.8 }} className="relative z-10 w-24 h-24 sm:w-32 sm:h-32 flex items-center justify-center">
        <div className="absolute w-16 h-16 sm:w-24 sm:h-24 bg-accent-maroon/15 rounded-full blur-xl animate-pulse" />
        <motion.div animate={{ rotate: 360 }} transition={{ duration: 4, repeat: Infinity, ease: 'linear' }} className="absolute w-24 h-24 sm:w-32 sm:h-32 border-[2px] sm:border-[3px] border-accent-maroon/20 border-dashed rounded-full" />
        <motion.div animate={{ rotate: -360 }} transition={{ duration: 2.5, repeat: Infinity, ease: 'linear' }} className="absolute w-20 h-20 sm:w-[7.5rem] sm:h-[7.5rem] border-2 border-transparent border-t-accent-maroon border-b-accent-maroon rounded-full" />
        <motion.div animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }} className="w-16 h-16 sm:w-24 sm:h-24 rounded-full overflow-hidden bg-white/80 border border-accent-maroon/30 p-1.5 sm:p-2 flex items-center justify-center backdrop-blur-sm z-20">
          <img src="/logo.png" alt="Mission Mewar Samriddhi Logo" className="w-full h-full object-contain rounded-full" />
        </motion.div>
      </motion.div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="text-center px-4">
        <h1 className="text-2xl sm:text-4xl font-bold bg-gradient-to-r from-accent-maroon to-accent-maroonDark bg-clip-text text-transparent">
          MissionMewarSamriddhi
        </h1>
        <p className="text-gray-600 mt-1 sm:mt-2 text-xs sm:text-sm">Clean City. Bright Future.</p>
      </motion.div>

      <motion.div initial={{ width: 0 }} animate={{ width: '100%' }} transition={{ duration: 2.5, ease: 'easeInOut' }} className="h-1 bg-gradient-to-r from-accent-maroon to-accent-maroonDark rounded-full w-48 sm:w-64" />

      <motion.p animate={{ opacity: [0.5, 1, 0.5] }} transition={{ duration: 1.5, repeat: Infinity }} className="text-gray-600 text-xs sm:text-sm">
        Preparing your experience...
      </motion.p>
    </motion.div>
  )
}

export default LoadingScreen